class NormaCardGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.ncg__track');
    this.slides = Array.from(this.querySelectorAll('.ncg__slide'));
    this.dots = Array.from(this.querySelectorAll('.ncg__dot'));
    this.prevBtn = this.querySelector('.ncg__arrow--prev');
    this.nextBtn = this.querySelector('.ncg__arrow--next');

    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.updateControls();

    // 2.+ görseller ancak kullanıcı galeriyle etkileşince yüklenir (iOS'ta yakınlaştırınca bellek çökmesini önler)
    // 22 Eki: touchstart kaldırıldı — sayfa kaydırılırken/yakınlaştırılırken parmağın değdiği her kartın galerisi yükleniyordu.
    // Dokunmatikte yalnızca galeri gerçekten yatay kaydırılınca, masaüstünde fare kartın üzerine gelince yüklenir.
    const load = () => this.loadImages();
    this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') load(); }, { passive: true });
    this.addEventListener('focusin', load, { once: true });
    this.track.addEventListener('scroll', load, { passive: true, once: true });

    this.prevBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index - 1);
    });

    this.nextBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.goTo(this.index + 1);
    });

    this.track.addEventListener(
      'scroll',
      () => {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => this.syncIndexFromScroll(), 100);
      },
      { passive: true }
    );
  }

  loadImages() {
    if (this.loaded) return;
    this.loaded = true;
    this.querySelectorAll('img[data-src], img[data-srcset]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  }

  goTo(nextIndex) {
    this.loadImages();
    const clamped = Math.max(0, Math.min(this.slides.length - 1, nextIndex));
    this.track.scrollTo({ left: this.slides[clamped].offsetLeft, behavior: 'smooth' });
  }

  syncIndexFromScroll() {
    const width = this.track.clientWidth || 1;
    this.index = Math.round(this.track.scrollLeft / width);
    this.updateControls();
  }

  updateControls() {
    this.dots.forEach((dot, i) => dot.classList.toggle('ncg__dot--active', i === this.index));

    if (this.prevBtn) this.prevBtn.style.visibility = this.index === 0 ? 'hidden' : 'visible';
    if (this.nextBtn) {
      this.nextBtn.style.visibility = this.index === this.slides.length - 1 ? 'hidden' : 'visible';
    }
  }
}

if (!customElements.get('norma-card-gallery')) {
  customElements.define('norma-card-gallery', NormaCardGallery);
}
